export default "__VITE_ASSET__BQdeK$lb__"